namespace advisorop.components.servicer {

    export class CustodianListController {
        custodianId: number;
        custodians: domains.ICustodian[];
        custodianName: string;
        editedCustodian: domains.ICustodian = {
            id: 0,
            hasOfficeRanges: false,
            address: {}
        };
        dg: DevExpress.ui.dxDataGridOptions;

        showAddModifyPanel: boolean = false;


        constructor(private servicerService: services.ServicerService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Custodians"
                },
                bindingOptions: {
                    dataSource: "vm.custodians"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                columns: [
                    { dataField: "name", caption: "Name" },
                    { dataField: "ibdNumber", caption: "IBD ID" },
                    { dataField: "ordNo", caption: "Ord. no.", sortOrder: "asc" },
                    { dataField: "hasOfficeRanges", caption: "Use Office Range / Master Accts?" },
                    { dataField: "id", caption: "#", cellTemplate: "btnActions", width: 70 }

                ],
                //selection: {
                //    mode: "single",
                //    showCheckBoxesMode: "onClick"
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.xxx({ id: data.id });
                //    }
                //}
            };
        }

        newCustodian(): void {
            this.editedCustodian = null;
            this.editedCustodian = {
                id: 0,
                hasOfficeRanges: false,
                address: {}
            };
            this.showAddModifyPanel = true;
        };

        editCustodian(custodian: domains.ICustodian) {
            if (!custodian.address)
                custodian.address = {};
            angular.copy(custodian, this.editedCustodian);
            //console.log(this.editedCustodian);
            this.custodianName = this.editedCustodian.name;

            //this.editedCustodian.id = custodian.id;
            //this.editedCustodian.name = custodian.name;
            //this.editedCustodian.ordNo = custodian.ordNo;
            //this.editedCustodian.status = custodian.status;
            //this.editedCustodian.hasOfficeRanges = custodian.hasOfficeRanges;

            this.showAddModifyPanel = true;
        };

        cancel(): void {
            this.editedCustodian = {};
            this.showAddModifyPanel = false;
        };

        custodianCreated(custodian): void {

            toastr.info("New IBD custodian has been successfully created");

            this.loadCustodians();

            this.cancel();

        };

        custodianModified(custodian): void {

            toastr.info("IBD Custodian has been successfully modified");

            this.loadCustodians();

            this.cancel();
        };

        loadCustodians(): void {
            this.servicerService.getCustodians()
                .then(data => {
                    this.custodians = data.data;
                    //console.log(data.data);
                })
                .catch(err => {
                    toastr.error("GETCUSTODIANS ERROR " + err.status + " " + err.data);
                });
        };

        $onInit(): void {
            this.loadCustodians();
        }

        $onChanges(evt): void {
            for (var key in evt) {
            }
        }

    }

    class CustodianList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                custodianId: "<"
            };
            this.controller = ["servicerService", CustodianListController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/custodian-list.html";
        }
    }
    angular.module(Constants.APP).component("custodianList", new CustodianList());

}